import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import axios from "../../api/axios";
import { filterTrackedEntitiesByCreatedAt, formatDataGeneral, getAttributeValue, getDataByTypes } from "../../utils/utils";
import APRComment from "./APRComment.js/AprComments";
import APRmemo from "./APRComment.js/APRmemo";


const Annex3b = forwardRef(({ year, district, period, hideTableDis, assessmentStatus }, ref) => {

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getProjects();
  }, [year, district, period]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "Annex_3b",
      tableData
    }),
  }));

  function getProjects() {
    axios
      .get(`/tracker/trackedEntities?orgUnit=${district}&program=g3wMUKEMmH3&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
      .then(result => {

        if (result.data.instances.length > 0) {

          axios
            .get(`/tracker/events?program=g3wMUKEMmH3&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
            .then(resp => {
              const data = filterTrackedEntitiesByCreatedAt(result.data.instances, year, period);
              const maintenance = [
                "Rehabilitation", "Extension", "Spot", "Improvement", "Spot Improvement"
              ]
              const maintenanceProjects = getDataByTypes(data, "Project Focus", maintenance) || [];

              const reports = resp.data.instances;
              const temp = [];

              maintenanceProjects.forEach((project, idx) => {

                const currentReport = reports.filter(rep => rep.trackedEntity === project.trackedEntity);
                let observation = "";
                let expenditure = 0;

                if (currentReport) {

                  currentReport.forEach(curReport => {
                    curReport.dataValues.forEach(rep => {
                      if (rep.dataElement === "tprVkQQg1wm") {
                        observation = rep.value;
                      }

                      if (rep.dataElement === "jr8gk707kAw") {
                        expenditure = rep.value;
                      }

                    });
                  })

                }

                const estimatedCost = getAttributeValue("Estimated Cost", project);
                const actualReleased = getAttributeValue("Actual Release", project);

                const dataSetTemp = {
                  no: idx + 1,
                  description: getAttributeValue("Description", project),
                  location: getAttributeValue("Location", project),
                  maintenance: getAttributeValue("Project Focus", project),
                  estimatedCost: estimatedCost,
                  actualReleased: actualReleased,
                  gap: parseFloat(estimatedCost) - parseFloat(actualReleased),
                  expenditure,
                  observation
                };

                temp.push(dataSetTemp);
              });

              setTableData(temp);

            })
            .catch(err => console.log(err))
        }


      })
      .catch(err => console.log(err))
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px'
  };

  const thStyle = {
    border: '1px solid #000',
    fontWeight: 'bold',
    backgroundColor: '#d4edda',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '8px'
  };

  const tdStyle = {
    border: '1px solid #000',
    verticalAlign: 'top',
    padding: '8px'
  };

  return (
    <div className="col-12" style={{ width: '100%', padding: 0 }}>
      <h3>Annex 3b: Repair and Maintenance of Existing Infrastructure</h3>
      <div className="card" style={{ width: '100%' }}>
        <div className="card-header">
        </div>
        <div className="card-body" style={{ width: '100%', padding: '20px', overflowX: 'auto' }}>
          <APRmemo
            year={year}
            districtId={district}
            tableCommentedId={`Annex_3b-${year}`}
            hideTableDis={hideTableDis}
            assessmentStatus={assessmentStatus}
            period={period}
          />

          <div className="table-responsive" style={{ width: '100%' }}>
            <table className="table table-bordered" style={tableStyle}>
              <thead>
                <tr>
                  <th style={{ ...thStyle, width: '5%' }}>S/N</th>
                  <th style={{ ...thStyle, width: '20%' }}>Asset/Infrastructure</th>
                  <th style={{ ...thStyle, width: '15%' }}>Location</th>
                  <th style={{ ...thStyle, width: '15%' }}>Type of Maintenance</th>
                  <th style={{ ...thStyle, width: '10%' }}>Estimated Cost</th>
                  <th style={{ ...thStyle, width: '10%' }}>Actual Release</th>
                  <th style={{ ...thStyle, width: '8%' }}>Gap</th>
                  <th style={{ ...thStyle, width: '8%' }}>Expenditure</th>
                  <th style={{ ...thStyle, width: '9%' }}>Recommendation</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td style={tdStyle}>{row.no}</td>
                    <td style={tdStyle}>{row.description}</td>
                    <td style={tdStyle}>{row.location}</td>
                    <td style={tdStyle}>{row.maintenance}</td>
                    <td style={tdStyle}>{row.estimatedCost}</td>
                    <td style={tdStyle}>{row.actualReleased}</td>
                    <td style={tdStyle}>{row.gap}</td>
                    <td style={tdStyle}>{row.expenditure}</td>
                    <td style={tdStyle}>{row.observation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-2">
            <small>Source: MPCU</small>
          </p>

          <APRComment
            data={tableData}
            year={year}
            districtId={district}
            tableCommentedId={`table7-${year}`}
          >
            {({ renderCommentInput, renderCommentList }) => (
              <>
                {renderCommentInput()}
                {renderCommentList()}
              </>
            )}
          </APRComment>
        </div>
      </div>
    </div>
  );
});

export default Annex3b;